import { render, staticRenderFns } from "./TanggapDarurat.vue?vue&type=template&id=3bc577b3&scoped=true&"
import script from "./TanggapDarurat.vue?vue&type=script&lang=js&"
export * from "./TanggapDarurat.vue?vue&type=script&lang=js&"
import style0 from "./TanggapDarurat.vue?vue&type=style&index=0&id=3bc577b3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc577b3",
  null
  
)

export default component.exports